import { render, staticRenderFns } from "./canvas-astrolabe.vue?vue&type=template&id=70845612&scoped=true&"
import script from "./canvas-astrolabe.vue?vue&type=script&lang=js&"
export * from "./canvas-astrolabe.vue?vue&type=script&lang=js&"
import style0 from "./canvas-astrolabe.vue?vue&type=style&index=0&id=70845612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70845612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70845612')) {
      api.createRecord('70845612', component.options)
    } else {
      api.reload('70845612', component.options)
    }
    module.hot.accept("./canvas-astrolabe.vue?vue&type=template&id=70845612&scoped=true&", function () {
      api.rerender('70845612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas-astrolabe.vue"
export default component.exports